import { init } from './methods/init/init';
import { send } from './methods/send/send';
import { sendForm } from './methods/sendForm/sendForm';
export { init, send, sendForm };
export default {
    init,
    send,
    sendForm,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emailjs/browser/es/index.js
// module id = 528
// module chunks = 0